import Skeleton from "react-loading-skeleton";

export const generateCorporateDocketSkeletonData = (count = 20) => Array.from({ length: count }, (_, index) => ({
    code: <Skeleton width={100} />,
    created_at: <Skeleton width={100} />,
    get_circuit: {
        is_maintenance: <Skeleton width={100} />, // Placeholder value
        code: <Skeleton width={100} />,
        customer_id: <Skeleton width={100} />,
        customer_id_alt: <Skeleton width={100} />,
        location_a: <Skeleton width={100} />,
        address_a: <Skeleton width={150} />,
        location_b: <Skeleton width={100} />,
        address_b: <Skeleton width={150} />,
        ofc_distance: <Skeleton width={50} />,
    },
    get_team: { name: <Skeleton width={100} /> },
    get_team_executive: { name: <Skeleton width={100} /> },
    get_alt_team: { name: <Skeleton width={100} /> },
    get_field_team: { name: <Skeleton width={100} /> },
    get_problem: { title: <Skeleton width={150} /> },
    status: <Skeleton width={80} />,
    updated_at: <Skeleton width={100} />,
}));

// Default skeleton with 20 rows for backward compatibility
export const corporateDocketSkeletonData = generateCorporateDocketSkeletonData(20);

export const MobileCorporateDocketActionSkeleton = () => (
    <div className='col-12'>
        <div className="d-flex gap-1">
            <Skeleton width={40} height={35} className="btn-style-light" />
            <Skeleton width={40} height={35} className="btn-style-light" />
            <Skeleton width={40} height={35} className="btn-style-light" />
        </div>
    </div>
);

export const CorporateDocketActionSkeleton = () => (
    <div className="d-flex gap-1">
        <Skeleton height={38} width={45} />
        <Skeleton height={38} width={45} />
        <Skeleton height={38} width={45} />
    </div>
);